import { render, staticRenderFns } from "./demandUpdate.vue?vue&type=template&id=279c6a60&scoped=true&"
import script from "./demandUpdate.vue?vue&type=script&lang=js&"
export * from "./demandUpdate.vue?vue&type=script&lang=js&"
import style1 from "./demandUpdate.vue?vue&type=style&index=1&id=279c6a60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279c6a60",
  null
  
)

export default component.exports